import React, { useEffect, useState } from "react"

import HeaderSearch from "./HeaderSearch"
import HeaderMenuNotifications from "./HeaderMenuNotifications"
import HamburgerMenu from "../Icons/HamburgerMenu"
import HeaderMenuWeather from "./HeaderMenuWeather"
import Accessibility from "../Icons/Accessibility"
import tw from "twin.macro"

const HeaderMenuRightIcons: React.FC<{
  mobileMenu: boolean
  setMobileMenu: React.Dispatch<React.SetStateAction<boolean>>
  handleMobileMenu(e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void
}> = ({ mobileMenu, setMobileMenu, handleMobileMenu }) => {
  const getTime = () => {
    const date = new Date()
    return (
      (date.getHours() > 12 ? date.getHours() - 12 : date.getHours()) +
      ":" +
      (date.getMinutes() < 10 ? "0" : "") +
      date.getMinutes() +
      (date.getHours() >= 12 ? "PM" : "AM")
    )
  }

  const [time, setTime] = useState(getTime)

  useEffect(() => {
    const interval = setInterval(() => setTime(getTime), 1000)
    return () => clearInterval(interval)
  }, [])

  const handleAccessibilityClick = () => {
    if (typeof loadService === "function") {
      loadService()
    }
  }

  return (
    <>
      <HeaderMenuNotifications setMobileMenu={setMobileMenu} />
      <HeaderSearch setMobileMenu={setMobileMenu} />
      <button
        id="enableReciteMobile"
        onClick={handleAccessibilityClick}
        aria-label="Enable accessibility tool"
        css={[
          tw`flex items-center transition-colors duration-500 rounded text-white px-2  2xl:hidden hover:(cursor-pointer bg-white text-black)`,
          tw`focus:(outline-none ring-2 ring-white ring-offset-2 ring-offset-transparent)`,
          tw`border-0 bg-transparent`,
        ]}
      >
        <Accessibility styling={[tw`h-8 w-8 stroke-current`]} />
      </button>
      <HamburgerMenu
        mobileMenu={mobileMenu}
        setMobileMenu={setMobileMenu}
        handleMobileMenu={handleMobileMenu}
      />

      <HeaderMenuWeather time={time} />
    </>
  )
}

export default HeaderMenuRightIcons
